<template>
  <div :class="classes" v-if="order">
    <pt-page-title title="生产任务单详情"></pt-page-title>
    <pt-sub-title title="任务单状态">
      <span slot="line" style="color:red;margin-left:10px;" v-if="order && order.isDelay">已延期</span>
      <pt-legend :statusArray="statusArray"></pt-legend>
    </pt-sub-title>
    <pt-lab-order-progress :class="$style['order_progress']" :order-status="statuses" :task="task" :order-detail="order" :tasks="tasks" :isTask="true"></pt-lab-order-progress>
    <!-- 状态操作需补充 -->
    <p v-if="isComplete" style="height:20px;"></p>
    <template v-else>
      <template v-if="order">
        <order-status :order-detail="order" :task="task" :status="nextStatus" :order="order" v-if="!this.$route.params.approval" @status-change="reload" :order-status="statuses" @isLoading="isLoading" :isTask="true">
        </order-status>
        <p v-else style="height:10px;"></p>
      </template>
    </template>
    <pt-sub-title title="任务单信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p>
          <span>任务单编号：</span>
          {{order.serialNumber}}
        </p>
        <p>
          <span>开始日期：</span>
          {{order.start_time}}
        </p>
        <p>
          <span>目标日期：</span>
          {{order.end_time}}
        </p>
        <p>
          <span>实验人员：</span>
          {{order.labTester.name}}
        </p>
        <p>
          <span>备注：</span>
          {{order.comment}}
        </p>
        <p v-if="order.billRemarks">
          <span>委托单备注：</span>
          {{order.billRemarks}}
        </p>
      </wt-box>
    </wt-grid>
    <pt-sub-title title="所属委托单信息"></pt-sub-title>
    <wt-grid :col="3" grid-gap="10px" :class="$style['order-info__box']">
      <wt-box :class="$style['order-info']">
        <p>
          <span>委托单编号：</span>
          {{bill ? bill.billCode :'--'}}
        </p>
        <!-- <p>
          <span>是否偏离：</span>
          {{bill ? bill.deviate_text : '--'}}
          {{bill ? bill.deviateInfo : ''}}
        </p> -->
        <p>
          <span>是否加急：</span>
          <template v-if="!bill">
            --
          </template>
          <template v-else>
            <el-tag type="danger" size="small" v-if="bill.urgent">加急</el-tag>
            <template v-else>否</template>
          </template>
        </p>
				<p>
          <span>交付方式：</span>
          {{bill ? bill.delivery_type :'--'}}
        </p>
        <p>
          <span>预计交付日期：</span>
          {{bill ? bill.delivery_date :'--'}}
        </p>
      </wt-box>
    </wt-grid>
    <pt-sub-title title="样品列表"></pt-sub-title>
    <lab-order-in-task :order="order" :bill="bill" ref="orderTable" :canSelect="true" comePage="taskDetail" :hasDownload="true"></lab-order-in-task>
    <div class="button-div">
			<el-button type="danger" plain v-if="isClosed" @click="goDelete">删除任务单</el-button>
			<template v-if="!isClosed && !isComplete">
      <el-button type="primary" @click="goEdit">编辑任务单</el-button>
      <el-button type="danger" plain @click="closeTask">关闭任务单</el-button>
		</template>
    </div>

    <!-- 选择样品 -->
    <select-lab-order-dialog orderStatusEnum='ORDER_RECEIVED' :dialogVisible="showDialog" :billId="bill ? bill.id : ''" :onlyNoBill="!bill" @close="showDialog = false" @selectData="getSelectData" :selectedKeys="[]" :noExportOption="true"></select-lab-order-dialog>
  </div>
</template>

<script>
import ptLegend from 'cps/base/pt-legend'
import orderStatus from 'cps/lab-order/order-status'
import { statusArray } from './options'
import ptLabOrderProgress from 'cps/lab-order/pt-lab-order-detail/pt-lab-order-progress'
import orderflowHelper from '@/config/order'
import labOrderInTask from '../lab-order-in-task.vue'
import selectLabOrderDialog from 'cps/common/select-lab-order-dialog.vue'
// 组件class前缀
const prefixCls = 'pt-production-task-detail'

export default {
  name: 'pt-production-task-detail',
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    statuses: {
      type: Array,
      default: () => []
    },
    tasks: {
      type: Array,
      default: () => []
    },
    bill: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isClosed () {
      return this.order && this.order.status === 'PRODUCTION_TASK_CLOSE'
    },
    isComplete () {
      return this.order && this.order.nextOrderAction === 'NONE'
    },
    nextStatus () {
      return this.order?.nextOrderAction
    }
  },
  components: {
    ptLegend,
    ptLabOrderProgress,
    orderStatus,
    labOrderInTask,
    selectLabOrderDialog
  },
  data () {
    return {
      orderflowHelper,
      statusArray,
      warningInfo: '',
      // task:{
      //   orderActionData:{
      //     nextActionResults:['CHONG_XIN_TI_GONG_YANG_PIN','ZHONG_ZHI','FEI_QI','HUI_FU'],
      //     action:'STEP_THREE'
      //   }
      // },
      task: null,
      selectOrder: [],
      removeLoading: false,
      distributeLoading: false,
      showDialog: false,
      addLoading: false
    }
  },
  methods: {
    isLoading (val) {
      this.$emit('handle-loading', val)
      // this.loading = val
    },
    reload () {
      console.log('---------reload')
      this.$refs.orderTable.reload()
      this.$emit('on-reload')
    },
    getSelectData (val) {
      console.log('===val', val)
      this.showDialog = false

      this.addLoading = true
      let data = {
        billId: this.bill.id,
        taskId: this.order.id,
        orderIds: val.map(e => e.id)
      }
      this.$store.dispatch('addOrdersToTask', data).then(res => {
        this.$message.success('操作成功')
        this.$emit('reload')
        this.$refs.orderTable.reload()
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.addLoading = false
      })
    },
    getSelectedOrder (data) {
      this.selectOrder = data
    },
    handleRemove () {
      if (!this.selectOrder.length) {
        this.$message.warning('请先勾选样品')
        return
      }
      this.$confirm(`您勾选了${this.selectOrder.length}条样品信息，是否确认从该任务单中移除?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.removeLoading = true
        let data = {
          billId: this.bill.id,
          taskId: this.order.id,
          orderIds: this.selectOrder.map(e => e.id)
        }
        this.$store.dispatch('removeOrdersFromTask', data).then(res => {
          this.$message.success('操作成功')
          this.$emit('reload')
          this.$refs.orderTable.reload()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.removeLoading = false
        })
      })
    },
    handleAdd () {
      this.showDialog = true
    },
    handleDistribute () {
      if (!this.selectOrder.length) {
        this.$message.warning('请先勾选样品')
        return
      }
      this.distributeLoading = true
      let data = {
        taskId: this.order.id,
        orderIds: this.selectOrder.map(e => e.id)
      }

      this.$store.dispatch('assginPre', data).then(data => {
        this.$router.push(`/distribute-task/${data.taskId}?isTask=true`)
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.distributeLoading = false
      })
    },
		goDelete(){
        this.loading = true
        this.$store.dispatch('deleteTask', this.order.id).then(res => {
          this.$message.success('操作成功')
					history.go(-1)
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.loading = false
        })
		},
    goEdit () {
      this.$router.push(`/production-task-form/true/${this.order.id}`)
    },
    handleClose () {
      this.$emit('handle-loading', true)
      this.$store.dispatch('closeTask', this.order.id).then((response) => {
        this.$message.success('关闭任务单成功！')
        this.$emit('on-reload')
      }).catch((error) => {
        this.$message.error(error + '关闭任务单失败！')
      }).finally(() => {
        this.$emit('handle-loading', false)
      })
    },
    closeTask () {
      this.$confirm(`该操作将关闭所有样品，如不需关闭下属样品，请提前进行分配`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!this.isComplete && this.order.status !== 'NO_ORDER') {
          this.$confirm(`您要关闭的样品中包含尚未完成检测的样品，请确认是否关闭，关闭将不可恢复。如需继续操作该样品，请对该样品进行重新分配。点击确定将继续关闭尚未完成的样品。`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleClose()
          })
        } else {
          this.handleClose()
        }
      })
    }
  }

}
</script>

<style module lang="less">
@import "~less/var.less";

/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.order-info__box {
  padding: 10px 20px;
}
.order-info-file__list {
  display: flex;
  padding: 10px 20px;
  :global {
    a {
      margin-left: 10px;
    }
    div {
      a {
        padding: 10px 0;
        display: block;
      }
    }
  }
}
.order-info {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color:#6D6D6D;

  > p >span:not(:global .el-tag){
    font-size: 14px;
    color: @mainColor;
    line-height: 30px;
  }
  :global{
    .el-button{
      padding: 3px 20px;
    }
  }
}

.order-info > div {
  span {
    display: block;
  }
}
</style>
